import { ticketActionTypes } from "./ticket.types";

// Carrega viewedTickets do localStorage se existir
const loadViewedTicketsFromStorage = () => {
  try {
    const stored = localStorage.getItem('quickAccessViewedTickets');
    if (stored) {
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed : [];
    }
  } catch (error) {
    console.error('Erro ao carregar viewedTickets do localStorage:', error);
  }
  return [];
};

const initialState = {
  tickets: [],
  loading: false,
  error: null,
  viewedTickets: loadViewedTicketsFromStorage()
};

function ticketReducer(state = initialState, action) {
  switch (action.type) {
    case ticketActionTypes.FETCH_TICKETS_START:
      return {
        ...state,
        loading: true,
        error: null
      };
    case ticketActionTypes.FETCH_TICKETS_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: action.payload,
        error: null
      };
    case ticketActionTypes.FETCH_TICKETS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case ticketActionTypes.SET_VIEWED_TICKETS:
      // Verifica se o limite foi atingido antes de adicionar
      const currentTickets = state.viewedTickets || [];
      const newTickets = action.payload || [];
      
      // Verifica se há flag de limite no localStorage
      const limitReached = localStorage.getItem('quickAccessLimitReached') === 'true';
      
      if (limitReached) {
        // Verifica se está tentando adicionar um novo item (não apenas atualizar existentes)
        const currentIds = new Set(currentTickets.map(t => t.id));
        const newIds = new Set(newTickets.map(t => t.id));
        const hasNewItem = Array.from(newIds).some(id => !currentIds.has(id));
        
        if (hasNewItem) {
          // Tentando adicionar um novo item, bloqueia
          // Mantém os itens atuais, não adiciona o novo
          return state;
        }
        // Se está removendo ou atualizando itens existentes, permite
      }
      
      // Persiste no localStorage
      try {
        localStorage.setItem('quickAccessViewedTickets', JSON.stringify(action.payload));
      } catch (error) {
        console.error('Erro ao salvar viewedTickets no localStorage:', error);
      }
      return {
        ...state,
        viewedTickets: action.payload
      };
    default:
      return state;
  }
}

export default ticketReducer;
